import { render, staticRenderFns } from "./TumKurslar.vue?vue&type=template&id=1130e37a&"
import script from "./TumKurslar.vue?vue&type=script&lang=js&"
export * from "./TumKurslar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports